import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Announcement = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 13 13"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M10.5 4.5V1.5L3.5 3.25M10.5 4.5C11.1667 4.5 12.5 4.9 12.5 6.5C12.5 8.1 11.1667 8.5 10.5 8.5M10.5 4.5V8.5M10.5 8.5V11.5L6.5 10.5M3.5 3.25L0.5 4V9L3.5 9.75M3.5 3.25V9.75M3.5 9.75V11C3.5 11.5 3.8 12.5 5 12.5C5.5 12.5 6.5 12.1 6.5 10.5M3.5 9.75L6.5 10.5" />
    </svg>
  ),
)
Announcement.displayName = 'Announcement'

export default Announcement
